import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Back, Next, ChatToAFitter } from '../ControlButtons';
import { SizeQuizExampleButton, SizeQuizButton } from '../selects/Buttons';
import { dataLayerGA4SizeQuizStageNumber } from '../../../shared/utils/data-layer';

const Stage9 = ({
  buttonSelected,
  cachedCupSize,
  cupChange,
  cupSize,
  defaultButtonProps,
  defaultNextProps,
  defaultPreviousProps,
  intl: { formatMessage },
  messages,
  partTwoButtonSelected,
  resetCup,
  setPartTwoSelected,
  setTempCupCache,
  showPartTwo,
  stage9aData,
  stage9bData,
  togglePartTwo,
}) => {
  const STAGE_NUMBER = '9';

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerGA4SizeQuizStageNumber(STAGE_NUMBER);
    togglePartTwo(false);
  }, []);

  return (
    <div className="stageContainer">
      <div className="standardQuestionContainer">
        <Back
          isThirdWidth
          {...defaultPreviousProps(3, formatMessage(messages.restartCupSize))}
          customFunc={() => {
            setPartTwoSelected(0);
            togglePartTwo(false);
            resetCup(cachedCupSize);
            setTempCupCache({ cupSize: cachedCupSize, cupChange: 0 });
          }}
        />
        <div className="stage stage-10">
          <div className="wrap wrap--left">
            <h4>{formatMessage(messages.stage9para1)}</h4>
            <SizeQuizExampleButton
              className="stage__tooltipBtn"
              message={formatMessage(messages.example)}
            />
            <div className="buttonsContainer">
              {stage9aData.map(({ func, text }, idx) => (
                <SizeQuizButton
                  key={idx}
                  {...defaultButtonProps(text, idx, func)}
                />
              ))}
            </div>
            {showPartTwo && (
              <div>
                <h4>{formatMessage(messages.stage9para2)}</h4>
                <div className="buttonsContainer">
                  {stage9bData.map(({ func, text }, idx) => (
                    <SizeQuizButton
                      key={idx}
                      {...defaultButtonProps(text, idx, func)}
                      partTwoSelected={partTwoButtonSelected}
                      setPartTwoSelected={setPartTwoSelected}
                    />
                  ))}
                </div>
              </div>
            )}

            <Next
              hasChevron
              disabled={showPartTwo ? !partTwoButtonSelected : !buttonSelected}
              {...defaultNextProps(1, 'Next question')}
              customFunc={() => {
                setPartTwoSelected(0);
                togglePartTwo(false);
                setTempCupCache({ cupSize: cupSize, cupChange: cupChange });
              }}
            />
          </div>
        </div>
      </div>
      <hr className="contentDivider" />
      <div id="fittersAdvice" className="contentContainer">
        <h4 className="contentHeader">
          {formatMessage(messages.adviceFromABraFitterHeader)}
        </h4>
        <p className="contentSubHeader">
          {formatMessage(messages.stage9para3)}
        </p>
        <ChatToAFitter stage={STAGE_NUMBER} />
      </div>
    </div>
  );
};

export default injectIntl(Stage9);

Stage9.propTypes = {
  Back: PropTypes.func,
  SizeQuizButton: PropTypes.func,
  buttonSelected: PropTypes.number,
  cachedCupSize: PropTypes.string,
  cupChange: PropTypes.number,
  cupSize: PropTypes.string,
  defaultButtonProps: PropTypes.func,
  defaultNextProps: PropTypes.func,
  defaultPreviousProps: PropTypes.func,
  intl: intlShape,
  messages: PropTypes.object,
  Next: PropTypes.func,
  partTwoButtonSelected: PropTypes.number,
  resetCup: PropTypes.func,
  setPartTwoSelected: PropTypes.func,
  showPartTwo: PropTypes.bool,
  setTempCupCache: PropTypes.func,
  stage9aData: PropTypes.array,
  stage9bData: PropTypes.array,
  togglePartTwo: PropTypes.func,
};
